import script from "./timeboardnew.vue?vue&type=script&setup=true&lang=js"
export * from "./timeboardnew.vue?vue&type=script&setup=true&lang=js"

import "./timeboardnew.vue?vue&type=style&index=0&id=427d1886&lang=less&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-427d1886"]])

export default __exports__